import * as React from "react";

function Search(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M14.026 12.348l3.57 3.568-1.18 1.179-3.568-3.57a7.467 7.467 0 01-4.681 1.642c-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5a7.466 7.466 0 01-1.641 4.68zm-1.672-.619A5.814 5.814 0 0014 7.667a5.832 5.832 0 00-5.833-5.834 5.831 5.831 0 00-5.834 5.834A5.832 5.832 0 008.167 13.5a5.814 5.814 0 004.062-1.646l.125-.125z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoSearch = React.memo(Search);
export default MemoSearch;
